import React from "react";
import Dropdown from "../Dropdown/Dropdown";

export default function DocumentOptions(props) {
  const dropdownData = [
    { id: 1, label: "Kreiraj izlazni dokument/akt" },
    { id: 2, label: "Učitaj izlazni dokument/akt" },
  ];

  const dropdownOptions = dropdownData.map((element) => (
    <option key={element.id} value={element.id}>
      {element.label}
    </option>
  ));

  return (
    <Dropdown
      hidden
      onChange={props.optionsHandler}
      value={props.optionPicked}
      asProperty="select"
      map={dropdownOptions}
      text="Odaberite"
      label="Kreiraj/učitaj izlazni dokument/akt"
      className="drop"
      id={1}
      name="izlazniDokument"
    />
  );
}
